<template>
  <b-row align-h="between" align-v="end" class="the-detail__head">
    <b-col>
      <h1>{{ticketTitle}}</h1>
    </b-col>
    <b-col cols="auto">
      <span v-on:click="closeSupportDetailPage" class="the-detail__head__windowcloser"><img src="images/icon/sitedetail/closer.svg" alt="Close Detailview"/></span>
    </b-col>
  </b-row>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  name: 'SupportTicketDetailBreadcrumb',

  props: {
    name: {
      default: '',
      type: String
    }
  },

  computed: {
    ticketTitle () {
      return this.name.length > 30 ? this.name.substring(0, 50) + ' ...' : this.name
    }

  },

  methods: {

    ...mapMutations('support', [
      'closeSupportDetailPage'
    ])

  }
}
</script>
